import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  constructor() { }

  private data = {};    

  setOption(option, value) {      
     this.data[option] = value;  
   }  
   
   getOption() {  
     return this.data;  
   }  

IsValidString(stringData:any):boolean
{
  if (stringData == null || stringData == '' || stringData == undefined) {
    return false;
  }

  return true;
}


}



// import { Injectable } from '@angular/core';  
  
// @Injectable()  
// export class DataService {  
  
//   private data = {};  
  
//  setOption(option, value) {      
//     this.data[option] = value;  
//   }  
  
//   getOption() {  
//     return this.data;  
//   }  
// }
